<template>
  <div class="bid-box">
    <div class="search-box">
      <div style="margin-top: 15px;">
        <el-input placeholder="产品名称" clearable v-model="form.Keyword">
          <el-button @click="search" slot="append" style="padding-left: 40px;padding-right: 40px;" type="primary"
              icon="el-icon-search">搜索
          </el-button>
        </el-input>
      </div>
    </div>
    <div class="tab-box">
      <ul>
        <li v-for="(item,index) in tabs" :key="index" :class="{activeLi:item.isActive}" @click="changeTab(item)">
          {{ item.text }}
        </li>
      </ul>
    </div>
    <div class="option-box">
      <div class="option-sty">
        <!--<span style="cursor: pointer;font-size: 14px;" @click="orderByList('desc')">默认</span>-->
        <span style="cursor: pointer;font-size: 14px;">默认</span>
        <!--<span class="price-by">价格</span>-->
        <!--<span class="icon-box">-->
        <!--<span class="el-icon-caret-top icon-sty" @click="orderByList('asc')"></span>-->
        <!--<span class="el-icon-caret-bottom icon-sty" @click="orderByList('desc')"></span>-->
        <!--</span>-->
      </div>
      <div class="result-sty">
        <p>共找到<span>{{ TotalCount }}</span>个符合要求的产品</p>
      </div>
    </div>
    <div class="list-flex">
      <div class="bid-list" v-loading="bidLoading">
        <div v-if="bidList.length>0">
          <ul class="first-ul">
            <li v-for="(item,index) in bidList" :key="index">
              <div class="bid-pro">
                <img style="width: 100%;height: 100%;" :src="getPic(item)">

              </div>
              <div class="bid-detail">
                <div class="detail-title">
                  <img class="icon-biao" src="/static/images/bid/u56.svg">
                  <p>{{ item.F_ProductName }}</p>
                </div>
                <div class="detail-c">
                  <div class="item-b item-b1">
                    <p>起拍价：<span class="color-price">￥{{ item.F_StartPrice }}</span></p>
                    <p>开始时间：<span
                        style="font-size: 12px">{{
                        item.F_AutionStartTime.substring(0, 10)
                      }}&nbsp;{{ item.F_AutionStartTime.substring(11, item.F_AutionStartTime.length) }}</span>
                    </p>
                    <p>提货日期：<span>{{ item.F_ShipmentDateStr }}</span></p>
                  </div>
                  <div class="item-b">
                    <p>招标量：<span>{{ item.F_AutionNum }}吨</span></p>
                    <p>结束时间：<span style="font-size: 12px">
                    {{
                        item.F_AutionEndTime.substring(0, 10)
                      }}&nbsp;{{ item.F_AutionEndTime.substring(11, item.F_AutionEndTime.length) }}
                    </span></p>
                    <p>提货地：<span>{{ item.F_DeliveryPlace }}</span></p>
                  </div>
                  <div class="item-b">
                    <p>最小招标量：<span>{{ item.F_StartWeight }}吨</span></p>
                    <p>售货单位：<span>{{ item.F_WarehouseName }}</span></p>
                  </div>
                </div>
              </div>
              <div class="bid-btn">
                <div v-if="item.F_Status == 1" class="btn">未开始</div>
                <div v-if="item.F_Status == 2" class="btn btn-join" @click="joinIn(item)">参与</div>
                <div v-if="item.F_Status == 3" class="btn btn-over">已结束</div>
                <div v-if="item.F_Status == 4" class="btn btn-over">公示中</div>
              </div>
            </li>
          </ul>
          <el-pagination background
              style="margin-top: 10px;margin-bottom: 20px;"
              layout=" total, prev, pager, next"
              :current-page="currentpage"
              :page-size="pageSize"
              :total="TotalCount"
              @current-change="onCurrentChange"
          >
          </el-pagination>
        </div>
        <div v-else style="padding: 20px 0px;">
          <p style="text-align: center">
            <img src="/static/images/bid/u476.png">
          </p>
          <p style="font-size: 18px;font-weight: 600;text-align: center;color: #888888;">暂无数据</p>
        </div>
      </div>
      <div class="news-box">
        <div class="news-box-c">
          <p class="title-c"><span>招标公告</span><span class="more" @click="getMore">更多</span></p>
          <div class="news-list-li">
            <ul>
              <li v-for="(item,index) in newsList" :key="index">
                <p style="cursor: pointer;" @click="downloadIt(item)">[{{ item.F_CreateTime.substring(0,10) }}]&nbsp;&nbsp;{{ item.F_Title }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
<!--    弹窗-->
    <div>
      <el-dialog  center
          title="最新招标信息"
          :visible.sync="dialogVisible">
        <div v-html="newDialog"></div>
        <div slot="footer" class="dialog-footer">
          <el-button type="warning" @click="dialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        AuctionState: 'Executing',
        Keyword:''
      },
      dateTime:'',
      bidLoading: false,
      dialogVisible: false,
      newDialog:"",
      bidList: [],
      PageIndex: 1,
      url: {
        list: SZH.assets.api + '/Auction/GetPagingActionByCustom',
        JoinAuction: SZH.assets.api + '/Auction/JoinAuction',
        GetListNews: SZH.assets.api + '/Market/GetListNews',
        GetNews: SZH.assets.api + '/Market/GetCustomNews',
      },
      currentpage: 1,
      TotalCount: 0,
      pageSize: 10,
      tabs: [
        {
          isActive: true,
          text: '进行中',
          value: 'Executing'
        },
        {
          isActive: false,
          text: '招标历史',
          value: 'Down'
        }
      ],
      newsList: []
    }
  },
  methods: {
    getPic(item) {
      if (item.F_ProductImgUrl) {
        return SZH.assets.image + '/' + item.F_ProductImgUrl;
      } else {
        return '';
      }
    },
    onCurrentChange(v) {
      this.PageIndex = v;
      this.getBidList();
    },
    changeTab(it) {
      let self = this;
      self.PageIndex = 1;
      self.form.AuctionState = it.value;
      self.tabs.forEach(item => {
        item.isActive = false;
        if (it.text == item.text) {
          item.isActive = true;
        }
      });
      this.getBidList()
    },
    search() {
      let self = this;
      self.PageIndex = 1;
      self.getBidList()
    },
    joinIn(bid) {
      let self = this;
      self.bidLoading = true;
      self.$http.post(self.url.JoinAuction, {
        keyValue: bid.F_Id
      }).then(result => {
        if (result.state == true) {
          this.$router.push({
            path: '/menu/AuctionHallDetail',
            query: {id: bid.F_Id}
          });
        } else {
          self.$message.error(result.message);
        }
        self.bidLoading = false;
      }, () => {
        self.bidLoading = false;
        self.$message.error('数据保存失败，请检查您的网络是否可用。');
      });

    },
    getBidList() {
      let self = this;
      self.bidLoading = true;
      self.$http.post(self.url.list, {
        PageSize: 10,
        PageIndex: self.PageIndex,
        Data: self.form
      }).then(result => {
        if (result.state == true) {
          self.TotalCount = result.data.TotalCount;
          self.bidList = result.data.Data;
        } else {
          self.bidList = [];
          self.TotalCount = 0;
          // self.$message.error(result.message?result.message:'未查到数据');
          // self.$message.error('未查到数据');
        }
        self.bidLoading = false;
      }, () => {
        self.bidLoading = false;
        self.$message.error('数据保存失败，请检查您的网络是否可用。');
      });
    },
    GetListNewsFun() {
      let self = this;
      self.$http.post(self.url.GetListNews, {
        Count: 10
      }).then(result => {
        if (result.state == true) {
          self.newsList = result.data;
          // self.loadNewsDetail(self.newsList[0].F_Id)
        } else {
          self.newsList = []
        }
      }, () => {
        self.$message.error('数据保存失败，请检查您的网络是否可用。');
      });
    },
    //弹窗所用数据
    loadNewsDetail(){
      let self = this;
      self.$http.post(self.url.GetNews,{
        keyValue:""
      }).then(result=>{
        if(result.state == true && result.data){
          //判断时间
          self.getDate();
          if(result.data.F_StartTime && result.data.F_EndTime){
            let newStartTime = result.data.F_StartTime.replaceAll("T"," " );
            let newEndTime = result.data.F_EndTime.replaceAll("T"," " );
            console.log(self.dateTime,newStartTime,newEndTime);
            if(self.dateTime<newStartTime || self.dateTime >newEndTime){
              self.dialogVisible = false;
              self.newDialog =  ''
            }else{
              self.dialogVisible = true;
            self.newDialog = result.data.F_Content

            }
          }
        }else{
          console.log(result.message)
        }
      })
    },
    downloadIt(item) {
      this.$router.push({
        path: '/Menu/AuctionDownload',
        query: {
          Id: item.F_Id
        }
      });
      // console.log(item)
      // window.open(SZH.assets.image + '/' + item.F_AttachUrl)
    },
    getDate(){
      let yy = new Date().getFullYear()
      let MM = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let hour = new Date().getHours()
      let minutes = new Date().getMinutes()
      let seconds = new Date().getSeconds()

      if (MM < 10) {
          MM = '0' + MM
      }
      if (dd < 10) {
          dd = '0' + dd
      }

      let hh = hour < 10 ? '0' + hour : hour
      let mm = minutes < 10 ? '0' + minutes : minutes
      let ss = seconds < 10 ? '0' + seconds : seconds
      this.dateTime = yy + '-' + MM + '-' + dd + ' ' + hh + ':' + mm + ':' + ss
      console.log(this.dateTime)
    },
    getMore() {
      this.$router.push({
        path: '/menu/News'
      });

    }
  },
  destroyed() {
  },
  computed: {},
  components: {},
  mounted() {
    this.getBidList();
    this.loadNewsDetail();
    this.GetListNewsFun()
  }
}
</script>
<style type="text/css" src="./AuctionHallList.css" scoped></style>



// WEBPACK FOOTER //
// src/views/AuctionHall/AuctionHallList/AuctionHallList.vue